function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import { Base, LogoTab } from "@brandwatch/axiom-components";
import "./LogoPage.css";
const LOGO_HEIGHT = "7.75rem";
const LOGO_COLOR_MAP = {
  night: "grey",
  day: "white"
};
export default class LogoPage extends Component {
  render() {
    const {
      backgroundImage,
      children,
      theme,
      ...rest
    } = this.props;
    const classes = classnames("ax-logo-page", `ax-logo-page--${theme}`);
    const style = {
      backgroundImage: backgroundImage && `url(${backgroundImage})`,
      paddingBottom: LOGO_HEIGHT
    };
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      className: classes,
      style: style,
      theme: theme
    }), /*#__PURE__*/React.createElement("div", {
      className: "ax-logo-page__header"
    }, /*#__PURE__*/React.createElement(LogoTab, {
      color: LOGO_COLOR_MAP[theme],
      height: LOGO_HEIGHT
    })), /*#__PURE__*/React.createElement("div", {
      className: "ax-logo-page__body"
    }, children));
  }

}